import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccessComponent } from './login/access/access.component';
import { QuoteEstimatorComponent } from './quote-estimator/quote-estimator.component';
import { AuthGuard } from './shared/guard/auth.guard';
import {CountryGuidesComponent} from './country-guides/country-guides.component';
import {CountryGuideDetailComponent} from './country-guides/country-guide-detail/country-guide-detail.component';
import {CountryGuideComponent} from './country-guides/country-guide/country-guide.component';
import {MyTalentRateComponent} from './my-talent-rate/my-talent-rate.component';
import {MyTalentSearchComponent} from './my-talent-search/my-talent-search.component';
import { WorkerProfileComponent } from './worker-profile/worker-profile/worker-profile.component';
import { WorkerProfileDetailComponent } from './worker-profile/worker-profile-detail/worker-profile-detail.component';

const routes: Routes = [
  { 
    path: '', 
    pathMatch: 'full', 
    redirectTo: 'login' 
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'access',
    component: AccessComponent
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'assignments',
    loadChildren: () => import ('./assignments/assignments.module').then((m) => m.AssignmentsModule),
    canLoad: [AuthGuard] 
  },
  {
    path: 'quotes',
    loadChildren: () => import ('./quotes/quotes.module').then((m) => m.QuotesModule),
    canLoad: [AuthGuard] 
  },
  {
    path: 'invoices',
    loadChildren: () => import ('./invoice/invoice.module').then((m) => m.InvoiceModule),
    canLoad: [AuthGuard] 
  },
  {
    path: 'vendor-invoices',
    loadChildren: () => import('./vendor-invoices/vendor-invoices.module').then((m)=> m.VendorInvoicesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'us-eor-quotes',
    loadChildren: () => import('./us-eor-quotes/us-eor-quotes.module').then((m)=> m.UsEorQuotesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'quoteEstimator/:id',
    component: QuoteEstimatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'myGuides',
    component: CountryGuidesComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'countryGuideDetail/:ID', 
    component: CountryGuideDetailComponent, 
    canActivate: [AuthGuard] 
  },
  { 
    path: 'countryGuide', 
    component: CountryGuideComponent, 
    canActivate: [AuthGuard] 
  },
  { 
    path: 'my-talent-rate', 
    component: MyTalentRateComponent,
    canActivate: [AuthGuard] 
  },
  { 
    path: 'my-talent-search', 
    component: MyTalentSearchComponent, 
    canActivate: [AuthGuard] 
  },
  {
    path: 'worker-profile',
    component: WorkerProfileComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'worker-profile-detail',
    component: WorkerProfileDetailComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
